import script from "./ActiveConversationMessages.vue?vue&type=script&setup=true&lang=ts"
export * from "./ActiveConversationMessages.vue?vue&type=script&setup=true&lang=ts"

import "./ActiveConversationMessages.vue?vue&type=style&index=0&id=5dd98baf&scope=true&lang=postcss"

export default script